module.exports = __webpack_public_path__ + "img/menulotlao.959af386.png";